/* Página atualizada e funcionando

Essa parte de layouts serve para chamar o código que está em pages, onde tudo é realmente montado.

*/

import ExcelenciaProj from "pages/CentroExcelencia/Projetos";

export default function ProjetosPage() {
  return <ExcelenciaProj />;
}
